<script>
import CInputCheckbox from './CInputCheckbox'

export default {
  name: 'CInputRadio',
  extends: CInputCheckbox,
  type: 'radio'
}
</script>
